import * as React from 'react';

import Spinner from '../../../../spinner/Spinner.jsx';

export type SurveyLoadingInlineProps = {
  children?: React.ReactNode;
};

const SurveyLoadingInline = ({ children }: SurveyLoadingInlineProps) => (
  <div className="survey-loading-inline">
    <Spinner />
    {children}
  </div>
);

export default SurveyLoadingInline;
